import { IEvent, IFeaturedEventViewModel } from '@/shared/types/swagger'
import { mainService, emmaApiService } from '.'

type GetEventsReturn = {
  items: Array<IEvent>
  count: number
}

type GetEventsParams = {
  page: number,
  pageSize: number
}

const serviceWithTags = emmaApiService.enhanceEndpoints({ addTagTypes: ['Events', 'FeaturedEvent'],  })

const eventServices = serviceWithTags.injectEndpoints({
  endpoints(build) {
    return {
      getEvents: build.query<GetEventsReturn, GetEventsParams>({
        query: ({ page, pageSize }) => (
          { 
            url: `/Event/getall?page=${page}&pageSize=${pageSize}`,
            method: 'GET'
          }
        ),
        providesTags: ['Events']
      }),
      getFeaturedEvent: build.query<IFeaturedEventViewModel, void>({
        query: () => (
          { 
            url: '/Event/getfeatured',
            method: 'GET'
          }
        ),
        providesTags: ['FeaturedEvent']
      }),
      getUpcomingEvents: build.query<Array<IEvent>, void>({
        query: () => (
          { 
            url: '/Event/getall?page=1&pageSize=3',
            method: 'GET'
          }
        ),
        transformResponse: (response: { items: Array<IEvent>, count: number }) => response.items
      }),
      addEvent: build.mutation<IEvent, FormData>({
        query: (postEvent) => (
          { 
            url: '/Event/add',
            method: 'POST',
            data: postEvent
          }
        ),
        invalidatesTags: ['Events']
      }),
      updateEvent: build.mutation<IEvent, FormData>({
        query: (event) => (
          { 
            url: `/Event/update`,
            method: 'POST',
            data: event
          }
        ),
        invalidatesTags: ['Events', 'FeaturedEvent']
      }),
      updateFeatureControl: build.mutation<void, void>({
        query: () => ({
          url: '/Event/SetAutomatically',
          method: 'POST',
        }),
        invalidatesTags: ['FeaturedEvent', 'Events']
      }),
      deleteEvent: build.mutation<IEvent, IEvent['id']>({
        query: (eventId) => (
          { 
            url: `/Event/delete/${eventId}`,
            method: 'DELETE',
            data: eventId
          }
        ),
        invalidatesTags: ['Events', 'FeaturedEvent']
      }),
    }
  },
})

export const { useGetEventsQuery, useGetUpcomingEventsQuery, useGetFeaturedEventQuery, useDeleteEventMutation, useAddEventMutation, useUpdateEventMutation, useUpdateFeatureControlMutation } = eventServices
